import './Alert.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faInfoCircle,
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons'

const severityIcons = {
  info: faInfoCircle,
  success: faCheckCircle,
  warning: faExclamationTriangle,
  error: faTimesCircle,
}

const CustomAlert = ({
  severity = 'info',
  message,
  validationErrors = [],
  onClose,
  children,
  className = '',
}) => {
  const isValidation = validationErrors.length > 0
  const icon = severityIcons[severity] || faInfoCircle

  return (
    <div className={`custom-alert ${severity} ${className}`}>
      {onClose && (
        <button className="custom-alert-close" onClick={onClose}>
          ×
        </button>
      )}

      <div className="custom-alert-icon">
        <FontAwesomeIcon icon={icon} size="2x" />
      </div>

      <div className="custom-alert-content">
        {children || (message && <div>{message}</div>)}

        {isValidation && (
          <div className="custom-alert-errors">
            <ul className="custom-alert-list">
              {validationErrors.map((err, idx) => (
                <li key={`error-${idx}`}>{err}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default CustomAlert
